import { FC } from 'react'
import { useParams } from 'react-router'

import { List } from 'antd'

import { Page } from '../components/page'
import { useTagQuery } from '../graphql'

import { ArticleCard } from './blog/ArticleCard'

const Tag: FC = () => {
  const { slug = '' } = useParams()
  const { data, loading } = useTagQuery({ variables: { slug } })
  return (
    <Page
      loading={loading}
      title={data?.tag?.name}
      seo={{ metaTitle: data?.tag?.name ? [data?.tag?.name, 'TochkaGP'].join(' | ') : '' }}
    >
      <List
        grid={{ gutter: 16, xs: 1, column: 3 }}
        dataSource={data?.tag?.articles}
        renderItem={(it) => (
          <List.Item>
            <ArticleCard {...it} />
          </List.Item>
        )}
      />
    </Page>
  )
}

export { Tag as default }
